import script from "./MessageTemplatesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageTemplatesView.vue?vue&type=script&setup=true&lang=ts"

import "./MessageTemplatesView.vue?vue&type=style&index=0&id=bd602a04&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd602a04"]])

export default __exports__